import { render, staticRenderFns } from "./UserSettings.vue?vue&type=template&id=43296043&scoped=true"
import script from "./UserSettings.vue?vue&type=script&lang=js"
export * from "./UserSettings.vue?vue&type=script&lang=js"
import style0 from "./UserSettings.vue?vue&type=style&index=0&id=43296043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43296043",
  null
  
)

export default component.exports